import React, { useState, useEffect } from 'react'
import * as Routes from '../routes'
import {Helmet} from "react-helmet";
import { withRouter } from "react-router-dom";

function PageTitleComponent({ location: { pathname } }) {

    const [title, setTitle] = useState('')

    useEffect(() => {
        switch(pathname) {

            // privat routes
            case Routes.USERS_LIST: setTitle('Сотрудники | '); break;
            case Routes.DROPSHIPPERS_LIST: setTitle('Дропшипперы | '); break;
            case Routes.CATALOG_CATEGORIES: setTitle('Категории | '); break;
            case Routes.WAREHOUSE_SUPPLIERS: setTitle('Поставщики | '); break;
            case Routes.CATALOG_CHARACTERISTIC_GROUPS: setTitle('Вариации | '); break;
            case Routes.CATALOG_CHARACTERISTICS: setTitle('Характеристики | '); break;
            case Routes.CATALOG_PRODUCTS: setTitle('Товары | '); break;
            case Routes.CATALOG_DELETED_ORDERS: setTitle('Удаленные заказы | '); break;
            case Routes.SETTINGS_ORDER_STATUSES: setTitle('Статусы заказа | '); break;
            case Routes.SETTINGS_UTM: setTitle('UTM метки | '); break;
            case Routes.SETTINGS_CURRENCIES: setTitle('Валюты | '); break;
            case Routes.SETTINGS_PRODUCT_PRICE_GROUP: setTitle('Группы цен | '); break;
            case Routes.SETTINGS_BUSINESS_PROCESSES: setTitle('Бизнес процессы | '); break;
            case Routes.SETTINGS_MESSAGES_TEMPLATES: setTitle('Шаблоны СМС | '); break;
            case Routes.SCANSHEET_ORDERS_LIST: setTitle('Упаковка | Заказы | '); break;
            case Routes.SCANSHEET_PRODUCTS_LIST: setTitle('Упаковка | Товары | '); break;
            case Routes.FINANCES_BANK_TRANSACTIONS_LIST: setTitle('Банковские транзакции | '); break;
            case Routes.LEADS_LIST: setTitle('Лиды | '); break;
            case Routes.CLIENTS_LIST: setTitle('Клиенты | '); break;
            case Routes.MODULE_MANAGEMENT_LIST: setTitle('Модули | '); break;
            case Routes.MODULE_TURBOSMS_CONFIG: setTitle('Модули | Turbo SMS | '); break;
            case Routes.MODULE_IMPORT_CONFIG: setTitle('Модули | YML импорт | '); break;
            case Routes.MODULE_NOVAPOSHTA_CONFIG: setTitle('Модули | Новая Почта | '); break;
            case Routes.MODULE_LP_MIGRATION_CONFIG: setTitle('Модули | Lp CRM | '); break;
            case Routes.MODULE_AFTERSHIP_CONFIG: setTitle('Модули | Aftership | '); break;
            case Routes.MODULE_NEXTEL_CONFIG: setTitle('Модули | Nextel | '); break;
            case Routes.MODULE_CMS_ORDERS_CONFIG: setTitle('Модули | CMS импорт | '); break;
            case Routes.MODULE_WAREHOUSE_CONFIG: setTitle('Модули | MyWarehouse | '); break;
            case Routes.MODULE_PROM_UA_CONFIG: setTitle('Модули | Prom.ua | '); break;
            case Routes.MODULE_ROZETKA_CONFIG: setTitle('Модули | Rozetka | '); break;
            case Routes.MODULE_PRIVATBANK_CONFIG: setTitle('Модули | Приватбанк | '); break;
            case Routes.MODULE_MONOBANK_CONFIG: setTitle('Модули | Монобанк | '); break;
            case Routes.MODULE_NPS_CONFIG: setTitle('Модули | NPS | '); break;
            case Routes.MODULE_DROPSHIPPER_CONFIG: setTitle('Модули | Дропшиппинг | '); break;
            case Routes.MODULE_SHOWCASE_CONFIG: setTitle('Модули | Витрина товаров | '); break;
            case Routes.MODULE_TILDA_CONFIG: setTitle('Модули | Tilda | '); break;
            case Routes.MODULE_COMMERCE_ML: setTitle('Модули | Commerce ML | '); break;
            case Routes.MODULE_BINOTEL_CONFIG: setTitle('Модули | Binotel | '); break;
            case Routes.MODULE_PHONET_CONFIG: setTitle('Модули | Phonet | '); break;
            case Routes.MODULE_HOROSHOP_CONFIG: setTitle('Модули | Хорошоп | '); break;
            case Routes.MODULE_CHATBOT_CONFIG: setTitle('Модули | Чат боты | '); break;
            case Routes.MODULE_UKRPOSHTA_CONFIG: setTitle('Модули | УкрПошта | '); break;
            case Routes.MODULE_WAYFORPAY_CONFIG: setTitle('Модули | WayForPay | '); break;

            case Routes.INVOICE_CREATE: setTitle('Биллинг | Создание платежа | '); break;
            case Routes.INVOICE_CREATE_PERSONAL: setTitle('Биллинг | Создание персонального платежа | '); break;
            case Routes.INVOICE_MODULES_CREATE: setTitle('Биллинг | Продление модуля | '); break;
            case Routes.INVOICE_LIST: setTitle('Биллинг | '); break;
            case Routes.MARKETING: setTitle('Маркетинг | '); break;
            case Routes.PROFILE: setTitle('Профиль | '); break;
            case Routes.REPORT: setTitle('Аналитика | Финансовая аналитика | '); break;
            case Routes.REPORT_ORDERS_PRIME_COST: setTitle('Аналитика | Себестоимость заказов | '); break;
            case Routes.REPORT_CALLS: setTitle('Аналитика | Звонки | '); break;
            case Routes.NPS_ANALYTICS: setTitle('Аналитика | NPS | '); break;
            case Routes.COMPANY_ACTIVITY: setTitle('Аналитика | Действия сотрудников | '); break;
            case Routes.SYSTEM_ACTIONS: setTitle('Системные действия | '); break;
            case Routes.USER_TASKS: setTitle('Задачи сотрудника | '); break;
            case Routes.MARKETING_COSTS: setTitle('Маркетинговая стоимость | '); break;
            case Routes.CHAT: setTitle('Чат боты | '); break;
            case Routes.CUSTOMER_DEVELOPMENT: setTitle('Разработка | '); break;

            // public routes
            case Routes.LOGIN: setTitle('Вход | '); break;
            case Routes.LOGOUT: setTitle('Выход | '); break;
            case Routes.REGISTRATION: setTitle('Регистрация | '); break;
            case Routes.FORGOT_PASSWORD: setTitle('Сброс пароля | '); break;
            case Routes.RESET_PASSWORD: setTitle('Сброс пароля | '); break;

            default: setTitle('')
        }
    }, [pathname]);

    return(
        <Helmet>
            <title>{`${title}`}BeClear CRM</title>
        </Helmet>
    )
}

export default withRouter(PageTitleComponent);
